/*
 * @Author: WUJUN
 * @Date: 2019-10-25 11:15:10
 * @LastEditTime: 2021-06-18 13:59:18
 * @LastEditors: Please set LastEditors
 * @Description:
 */
import Vue from 'vue';
import Router from 'vue-router';

//  懒路由加载
// const home = r => require.ensure([], () => r(require('@/pages/home/home')), 'home')

const _import = (path) => () => import(`@/pages/${path}`);

Vue.use(Router);

// 重复点击路由报错解决
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: {
        alias: '首页'
      }
    },
    {
      name: 'home',
      path: '/home',
      meta: {
        index: 1,
        alias: '首页'
      },

      component: _import('home')
    },
    {
      name: 'external',
      path: '/external',
      meta: {
        index: 2
      },

      component: _import('external')
    },
    {
      name: 'order',
      path: '/order',
      meta: {
        index: 2,
        role: true,
        alias: '订单'
      },
      component: _import('order')
    },
    {
      path: '/detail/:id',
      name: 'detail',
      meta: {
        index: 3,
        role: true,
        alias: '订单详情'
      },
      component: () => import('@/pages/order/detail/index')
    },
    // entity
    {
      path: '/entity/:id',
      name: 'entity',
      meta: {
        index: 5,
        role: true,
        alias: '订单详情'
      },
      component: () => import('@/pages/order/detail/entity')
    },
    {
      path: '/refund/:id',
      name: 'refund',
      meta: {
        index: 5,
        role: true,
        alias: '订单详情'
      },
      component: () => import('@/pages/order/detail/refund')
    },
    {
      path: '/Explain',
      name: 'Explain',
      meta: {
        index: 4,
        alias: '售后服务说明'
      },
      component: () => import('@/pages/order/detail/Explain')
    },
    {
      path: '/rules',
      name: 'rules',
      meta: {
        index: 2,
        alias: '友米规则说明'
      },
      component: _import('rules')
    },
    {
      path: '/log',
      name: 'log',
      meta: {
        role: true,
        index: 2,
        alias: '友米明细'
      },
      component: _import('log')
    },
    {
      path: '/market',
      name: 'market',
      meta: {
        index: 2,
        alias: '商品列表'
      },
      component: _import('market')
    },
    {
      path: '/exchangeDetail/:id',
      name: 'exchangeDetail',
      meta: {
        index: 4,
        role: true,
        alias: '兑换详情页面'
      },
      component: () => import('@/pages/market/productDetail/exchangeDetail')
    },
    {
      path: '/productDetail/:id',
      name: 'productDetail',
      meta: {
        index: 3,
        alias: '商品详情页面'
      },
      component: () => import('@/pages/market/productDetail')
    },
    {
      path: '/myCenter',
      name: 'myCenter',
      meta: {
        index: 5,
        role: true,
        alias: '我的中心页面'
      },
      component: () => import('@/pages/mine/myCenter')
    },
    {
      path: '/myNews',
      name: 'myNews',
      meta: {
        index: 6,
        role: true,
        alias: '我的消息页面'
      },
      component: () => import('@/pages/mine/myNews')
    },
    {
      path: '/topic/:id',
      name: 'topic',
      meta: {
        index: 7,
        role: true,
        alias: '我的消息详情页面'
      },
      component: () => import('@/pages/mine/topic')
    },
    {
      path: '/orderInfo',
      name: 'orderInfo',
      meta: {
        index: 8,
        role: true,
        alias: '订单通知列表页面'
      },
      component: () => import('@/pages/mine/orderInfo')
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: {
        index: 9,
        role: true,
        alias: '问题反馈页面'
      },
      component: () => import('@/pages/mine/feedback')
    },
    {
      path: '/myAddress',
      name: 'myAddress',
      meta: {
        index: 9,
        role: true,
        alias: '地址维护'
      },
      component: () => import('@/pages/address/myAddress')
    },
    {
      path: '/addressForm',
      name: 'addressForm',
      meta: {
        index: 10,
        role: true,
        alias: '编辑地址'
      },
      component: () => import('@/pages/address/addressForm')
    },
    {
      path: '/entityGoods',
      meta: {
        index: 11,
        alias: '兑换好物'
      },
      component: () => import('@/pages/market/entity/index')
    },
    {
      path: '/entityDetail/:id',
      name: 'entityDetail',
      meta: {
        index: 12,
        alias: '物品详情'
      },
      component: () => import('@/pages/market/entity/entityDetail')
    },
    {
      path: '/shoppingCar',
      name: 'shoppingCar',
      meta: {
        index: 13,
        role: true,
        alias: '购物车'
      },
      component: () => import('@/pages/shoppingCar/shoppingCar')
    },
    {
      path: '/submitOrder',
      name: 'submitOrder',
      meta: {
        index: 14,
        role: true,
        alias: '填写订单'
      },
      component: () => import('@/pages/order/submit/index')
    },
    {
      path: '/payment',
      name: 'payment',
      meta: {
        index: 14,
        alias: '支付收银台'
      },
      component: () => import('@/pages/payment/index')
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      meta: {
        index: 15,
        role: false,
        alias: '支付成功'
      },
      component: () => import('@/pages/payment/paySuccess')
    },
    {
      path: '/chooseAddress',
      name: 'chooseAddress',
      meta: {
        index: 16,
        role: true,
        alias: '地址选择'
      },
      component: () => import('@/pages/address/myAddress')
    },
    {
      path: '/modifyAddress/:id',
      name: 'modifyAddress',
      meta: {
        index: 17,
        role: true,
        alias: '修改地址'
      },
      component: () => import('@/pages/order/detail/modifyAddress')
    },
    {
      path: '/applyRefund',
      name: 'applyRefund',
      meta: {
        index: 18,
        role: true,
        alias: '申请退货/退款'
      },
      component: () => import('@/pages/order/applyRefund/index')
    },
    {
      path: '/payFailed',
      name: 'payFailed',
      meta: {
        index: 19,
        role: false,
        alias: '支付失败'
      },
      component: () => import('@/pages/payment/payFailed')
    },
    {
      path: '*', // 页面不存在的情况下会跳到404页面
      // redirect: '/404',
      component: _import('404')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// src/router/index.js